@if (loading) {
  <div>
    <rask-busy-spinner size="1"></rask-busy-spinner>
  </div>
}
@for (status of statuses; track status.header) {
  <div>
    <rask-atgard-header-icon [status]="status"></rask-atgard-header-icon>
  </div>
}